import { Link } from "react-router-dom";
import landingPagesGraphic from "@/assets/landing-pages-graphic.png";

export default function LandingPagesSection() {
  return (
    <section className="py-20 px-5 sm:px-8 bg-gradient-to-br from-slate-950 via-violet-950 to-slate-900 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

          {/* Left — description */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold mb-6">
              <i className="ri-pages-fill"></i>
              Included in Pro &amp; Elite · Add-on for Starter &amp; Growth
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-5 leading-tight">
              100+ Prebuilt Landing Pages
              <span className="block bg-gradient-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent">
                For Every Niche
              </span>
            </h2>
            <p className="text-slate-300 text-base leading-relaxed mb-6">
              Get a professionally designed, niche-specific landing page that captures leads, promotes your group, and connects to your email list — all without touching a line of code. Instant launch ready.
            </p>
            <ul className="space-y-3 mb-8">
              {[
                { icon: "ri-layout-grid-fill", text: "100+ industry-specific prebuilt templates" },
                { icon: "ri-mail-send-fill", text: "Built-in email autoresponder integrations" },
                { icon: "ri-user-received-2-fill", text: "Lead capture forms connected to your funnel" },
                { icon: "ri-edit-2-fill", text: "Easy drag-and-drop editing — no coding needed" },
                { icon: "ri-links-fill", text: "Direct link to your Skool group or offer" },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3 text-sm text-slate-300">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-amber-500/20 flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-amber-400 text-sm`}></i>
                  </div>
                  {item.text}
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/features/landing-pages"
                className="px-6 py-3 rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 text-white font-semibold text-sm hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              >
                See More Info
              </Link>
              <Link
                to="/get-started"
                className="px-6 py-3 rounded-xl border border-white/20 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                Get Started
              </Link>
            </div>
          </div>

          {/* Right — graphic */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-orange-500/20 rounded-3xl blur-3xl scale-110"></div>
            <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
              <img
                src={landingPagesGraphic}
                alt="100 prebuilt landing pages for every industry"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
